import {
  GET_PROFILE_DETAILS,
  GET_ALLOCATOR_Strategy,
  GET_STRATEGY,
  GET_ALL_INVESTOR,
  GET_COMPANY_POST_FEED,
  GET_COMPANY_USERS,
  CREATE_ALLOCATOR_NETWORKS,
  UPDATE_ALLOCATOR_NETWORKS,
  DELETE_ALLOCATOR_NETWORKS,
} from "./constants";

export function getProfileDetail(payload) {
  return {
    type: GET_PROFILE_DETAILS,
    payload,
  };
}

export function getAllocatorStrategy(payload) {
  return {
    type: GET_ALLOCATOR_Strategy,
    payload,
  };
}

export function getStrategy(payload) {
  return {
    type: GET_STRATEGY,
    payload,
  };
}

export function getallInvestor(payload) {
  return {
    type: GET_ALL_INVESTOR,
    payload,
  };
}

export function getCompanyPostFeed(payload) {
  return {
    type: GET_COMPANY_POST_FEED,
    payload,
  };
}

export function getCompanyUsersAction(payload) {
  return {
    type: GET_COMPANY_USERS,
    payload
  };
}

export function createAllocatorNetworks(payload) {
  return {
    type: CREATE_ALLOCATOR_NETWORKS,
    payload,
  };
}

export function updateAllocatorNetworks(payload) {
  return {
    type: UPDATE_ALLOCATOR_NETWORKS,
    payload,
  };
}

export function deleteAllocatorNetwork(payload) {
  return {
    type: DELETE_ALLOCATOR_NETWORKS,
    payload
  };
}